import * as React from 'react';
export const dataExportSvg = React.forwardRef(function dataExportSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.25 0H11a.75.75 0 1 0 0 1.5h2.44l-3.22 3.22a.75.75 0 1 0 1.06 1.06l3.22-3.22V5A.75.75 0 0 0 16 5V.75a.75.75 0 0 0-.75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 0C4.686 0 2 1.567 2 3.5v9C2 14.433 4.686 16 8 16s6-1.567 6-3.5V7.75a.75.75 0 0 0-1.5 0V8c0 .212-.16.681-1.013 1.18-.819.477-2.048.82-3.487.82s-2.668-.343-3.487-.82C3.658 8.68 3.5 8.211 3.5 8V5.815C4.6 6.542 6.208 7 8 7h.25a.75.75 0 0 0 0-1.5H8c-1.439 0-2.668-.343-3.487-.82C3.658 4.18 3.5 3.711 3.5 3.5c0-.212.158-.68 1.013-1.18C5.332 1.844 6.561 1.5 8 1.5h.25a.75.75 0 0 0 0-1.5H8ZM3.5 10.315V12.5c0 .211.158.68 1.013 1.18.819.477 2.048.82 3.487.82s2.668-.343 3.487-.82c.855-.5 1.013-.969 1.013-1.18v-2.185C11.4 11.042 9.792 11.5 8 11.5c-1.792 0-3.4-.458-4.5-1.185Z',
    }),
  );
});
dataExportSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dataExport = {
  category: 'icon',
  colorable: true,
  name: 'dataExport',
  svg: dataExportSvg,
};
